/* eslint-disable no-undef */
import feather from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';
import io from 'socket.io-client';
import {
  fetchUserDevice,
  fetchUserInfo,
  joinRotation,
  logout,
  reAuthenticate,
  setUserDetails
} from 'store/modules/login/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from 'store/modules/notifications/constants';
import { showNotification } from 'store/modules/notifications/actions';
import { getSignedInUser } from 'store/modules/login/functions';
import { reloadNow } from 'store/modules/app/actions';
import { omit, isEqual, isEmpty, round, random } from 'lodash';
import { leaveConference } from 'store/modules/app/actions';
import { SELECT_ROTATION_PARTICIPANT } from 'store/modules/large-video/actionTypes';
import { getRoomName } from 'store/modules/base/conference/functions';
import { isStageFilmstripAvailable } from 'store/modules/filmstrip/functions';
import { electParticipantInLargeVideo } from 'store/modules/large-video/actions';
import logger from 'store/modules/base/redux/logger';
import utils from './utils';

var isInitialConnect = true;
var joinInterval = false;
const socket = io(process.env.REACT_APP_BACKEND_URL, {
  reconnectionDelay: round(random(1, 5, true) / 0.5) * 0.5 * 1000,
  secure: true,
  query: {
    uuid: utils.fetchLocalUUID()
  }
});
socket.on('connect', async function () {
  let reconnect = false;
  if (isInitialConnect) {
    isInitialConnect = false;
    logger.info('connected');
  } else {
    logger.info('reconnected');
    reconnect = true;
  }

  try {
    const token = await feathers.authentication.getAccessToken();
    if (token) {
      logger.info('reauthenticate');
      APP.store.dispatch(reAuthenticate(reconnect));
    }
  } catch (e) {
    logger.error(e);
  }
});
socket.on('disconnect', function () {
  logger.info('disconnected');
  window.isAuthenticated = false;
});

// socket.io.on('reconnect', function () {
//   console.log('reconnected');
//   if (APP?.conference && APP?.conference.isJoined()) {
//     const { userSleepMode, userPrivacyMode, userExternalMode } =
//       APP.store.getState()['features/settings'];
//     if (!userSleepMode && !userPrivacyMode && !userExternalMode) {
//       APP.store.dispatch(updateDeviceStatus('live'));
//       APP.store.dispatch(joinRotation(getRoomName(APP.store.getState())));
//     }
//   }
// });
const feathers = feather.feathers();
const socketClient = socketio(socket);
feathers.configure(socketClient);
feathers.configure(
  auth({
    storage: window.localStorage,
    storageKey: process.env.REACT_APP_AUTH_STORAGE_KEY
  })
);
feathers.use('cluster', socketClient.service('cluster'), {
  methods: ['join', 'leave', 'ack']
});
feathers.use('statistic', socketClient.service('statistic'), {
  methods: ['collect']
});
export const isAuthenticated = async () => {
  const token = await feathers.authentication?.getAccessToken();
  return token;
};
const onUserRemoved = (data) => {
  const user = getSignedInUser(APP.store.getState());
  if (user._id === data?._id) {
    APP.store.dispatch(logout());
    APP.store.dispatch(
      showNotification(
        { titleKey: 'notify.userRemoved' },
        NOTIFICATION_TIMEOUT_TYPE.LONG
      )
    );
  }
};

const onUserPatched = (data) => {
  const user = getSignedInUser(APP.store.getState());
  if (user?._id === data?._id) {
    APP.store.dispatch(
      fetchUserDevice(user._id, () => {
        APP.conference.handleEventsUpdateUI(false);
      })
    );
    APP.store.dispatch(
      showNotification(
        { titleKey: 'notify.userUpdated' },
        NOTIFICATION_TIMEOUT_TYPE.LONG
      )
    );
  }
};

const onDeviceRemoved = (data) => {
  const user = getSignedInUser(APP.store.getState());
  if (user?.device?._id === data?._id) {
    APP.store.dispatch(logout());
    APP.store.dispatch(
      showNotification(
        { titleKey: 'notify.deviceRemoved' },
        NOTIFICATION_TIMEOUT_TYPE.LONG
      )
    );
  }
};

const onDevicePatched = (data) => {
  const user = getSignedInUser(APP.store.getState());
  if (user && user.device) {
    const { device } = user;
    if (device?._id === data?._id) {
      const devices = {
        ...device,
        city: device.city?._id,
        country: device.country?._id,
        timezone: device.timezone?._id
      };
      if (
        !isEqual(
          omit(devices, ['updatedAt', 'user', 'business', 'reseller']),
          omit(data, ['updatedAt', 'user', 'business', 'reseller'])
        )
      ) {
        if (APP.conference && APP.conference.isJoined()) {
          // eslint-disable-next-line no-prototype-builtins
          if (user?.device.hasOwnProperty('restartedAt')) {
            if (user?.device.restartedAt !== data?.restartedAt) {
              APP.store.dispatch(
                setUserDetails({
                  ...user,
                  device: { ...user.device, restartedAt: data?.restartedAt }
                })
              );
              APP.store.dispatch(reloadNow());
              APP.store.dispatch(
                showNotification(
                  { titleKey: 'notify.conferenceRestarted' },
                  NOTIFICATION_TIMEOUT_TYPE.LONG
                )
              );
              return;
            }
            // eslint-disable-next-line no-prototype-builtins
          } else if (data?.hasOwnProperty('restartedAt')) {
            APP.store.dispatch(reloadNow());
            APP.store.dispatch(
              showNotification(
                { titleKey: 'notify.conferenceRestarted' },
                NOTIFICATION_TIMEOUT_TYPE.LONG
              )
            );
            return;
          }
          // TODO: Review when re-implementing single device login enforcement
          // For now isConferenceLive will always return false
          if (utils.isConferenceLive(data.status)) {
            APP.store
              .dispatch(
                setUserDetails({
                  ...user,
                  device: { ...user.device, status: data.status }
                })
              )
              .then(() => {
                const isRemote = utils.isRemoteLogin(user);
                APP.store.dispatch(
                  leaveConference(isRemote ? '/groups' : '/settings')
                );
                APP.store.dispatch(
                  showNotification(
                    { titleKey: 'notify.conferenceForceLeave' },
                    NOTIFICATION_TIMEOUT_TYPE.LONG
                  )
                ); //TODO
                if (!isRemote) {
                  APP.store.dispatch(logout());
                }
              });

            return;
          }
        }
        const {
          preferredCodec,
          adaptiveMode,
          svcSimulcast,
          maxResolution,
          minResolution
        } = user.device?.options || {};
        if (
          preferredCodec !== data?.options?.preferredCodec ||
          adaptiveMode !== data?.options?.adaptiveMode ||
          svcSimulcast !== data?.options?.svcSimulcast ||
          maxResolution !== data?.options?.maxResolution ||
          minResolution !== data?.options?.minResolution
        ) {
          APP.store.dispatch(
            setUserDetails({
              ...user,
              device: { ...user.device, options: data?.options }
            })
          );
          APP.store.dispatch(reloadNow());
          APP.store.dispatch(
            showNotification(
              { titleKey: 'notify.conferenceRestarted' },
              NOTIFICATION_TIMEOUT_TYPE.LONG
            )
          );
          return;
        }
        APP.store.dispatch(
          fetchUserDevice(user._id, (rejoin) => {
            APP.conference.handleEventsUpdateUI(rejoin);
          })
        );
        APP.store.dispatch(
          showNotification(
            { titleKey: 'notify.deviceUpdated' },
            NOTIFICATION_TIMEOUT_TYPE.LONG
          )
        );
      }
    } else {
      const userProfiles = APP.store.getState()['features/login'].profiles;
      if (userProfiles[data?.user]) {
        APP.store.dispatch(fetchUserInfo(data?.user));
      }
    }
  }
};

const onBusinessPatched = (data) => {
  const user = getSignedInUser(APP.store.getState());
  if (user?.device?.business?._id === data?._id) {
    // eslint-disable-next-line no-prototype-builtins
    if (data?.hasOwnProperty('active') && !data.active) {
      APP.store.dispatch(logout());
      APP.store.dispatch(
        showNotification(
          { titleKey: 'notify.businessRemoved' },
          NOTIFICATION_TIMEOUT_TYPE.LONG
        )
      );
    } else {
      let temp = { ...user };
      temp.device.business = data;
      APP.store.dispatch(setUserDetails(temp));
    }
  }
};
// eslint-disable-next-line no-unused-vars
// feathers.io.onAny((eventName, data) => {
//   console.log('custom event', { eventName, ...data });
// });

feathers.on('login', (data) => {
  console.log('authenticated', data);
  if (data?.user) {
    window.isAuthenticated = true;
    if (data?.user?.device?._id) {
      APP.store.dispatch(setUserDetails(data?.user));
    } else {
      APP.store.dispatch(fetchUserDevice(data?.user._id));
    }
  }
  if (!isInitialConnect) {
    if (joinInterval) {
      clearInterval(joinInterval);
      joinInterval = undefined;
    }
    joinInterval = setInterval(() => {
      if (APP.conference) {
        if (APP.conference.isJoined()) {
          clearInterval(joinInterval);
          joinInterval = undefined;
          const { userSleepMode, userPrivacyMode, userExternalMode } =
            APP.store.getState()['features/settings'];
          if (!userSleepMode && !userPrivacyMode && !userExternalMode) {
            APP.store.dispatch(joinRotation(getRoomName(APP.store.getState())));
          }
        }
      }
    }, 1000);
  }
});
feathers.io.on('cluster pair', (data) => {
  console.log('rotation pair', data);
  APP.store.dispatch({
    type: SELECT_ROTATION_PARTICIPANT,
    participantId: data.user
  });
});
// eslint-disable-next-line no-unused-vars
feathers.io.on('cluster wait', (data) => {
  console.log('rotation wait', data);
  APP.store.dispatch({
    type: SELECT_ROTATION_PARTICIPANT,
    participantId: null,
    onStage: isStageFilmstripAvailable(APP.store.getState(), 1)
  });
  APP.store.dispatch(electParticipantInLargeVideo());
});

feathers.service('user').on('patched', onUserPatched);
feathers.service('user').on('removed', onUserRemoved);
feathers.service('device').on('patched', onDevicePatched);
feathers.service('device').on('removed', onDeviceRemoved);
feathers.service('business').on('patched', onBusinessPatched);
feathers.hooks({
  error(context) {
    console.error(context);
    const token = window.localStorage.getItem(
      process.env.REACT_APP_AUTH_STORAGE_KEY
    );
    console.log(context.error.code, token);
    if (context.error.code === 401 && !isEmpty(token)) {
      console.log('redirecting logout');
      APP.store.dispatch(logout());
    }
  }
});

export default feathers;
